import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'kiene-vvvo-hinzufuegen-hit',
    templateUrl: './vvvo-hinzufuegen-hit.component.html',
    styleUrls: ['./vvvo-hinzufuegen-hit.component.scss'],
})
export class VvvoHinzufuegenHitComponent implements OnInit {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {}

    goBack(): void {
        this.router.navigate(['../'], { relativeTo: this.route }).then();
    }
}
